/**
 * HelpQuestionsContainer
 * --
 */
import React from 'react';
import HelpQuestionsPresenter from './HelpQuestionsPresenter';
import { useDefaultShopDataStack, useUserStack } from 'store';

const HelpQuestionsContainer = (props) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  const { navigate, screenSize } = props;

  /* ===== Store ===== */
  const userInfo = useUserStack();
  const { faqList } = useDefaultShopDataStack();

  /* ===== STATE ===== */
  const [tap, setTap] = React.useState('ALL');
  const [expandedQuestion, setExpandedQuestion] = React.useState(null); // 현재 확장된 질문 ID
  const [currentPage, setCurrentPage] = React.useState(1); // 현재 페이지 번호

  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /**
   * 탭 핸들러
   * --
   * @param {string} status
   */
  const handleTapChange = (status) => {
    setTap(status);
    setCurrentPage(1); // 상태 변경 시 페이지를 첫 페이지로 초기화
    setExpandedQuestion(null); // 확장된 질문도 초기화
  };

  /**
   * FAQ 토글
   * --
   * @param {number} key
   */
  const handleToggleQuestion = (key) => {
    setExpandedQuestion(expandedQuestion === key ? null : key);
  };

  /**
   * 문의하기 라우팅 처리
   * --
   */
  const handleNavigate = () => {
    if (!userInfo) {
      const confirm = window.confirm(
        '로그인 후 이용가능합니다.\n로그인하시겠습니까?'
      );

      if (confirm) {
        return navigate('signin', {
          state: {
            from: `/cs/inquireform`,
          },
        });
      } else {
        return;
      }
    }

    navigate('/cs/inquireform');
  };

  /* ===== HOOKS ===== */
  /**
   * FAQ 목록 정제
   * --
   */
  const FAQ = React.useMemo(() => {
    const newFAQList = faqList.map((faq) => ({
      id: faq.inquiry_id,
      status: faq.inquiry_name, // TODO
      title: faq.inquiry_content,
      answer: faq.inquiry_answer,
    }));

    return newFAQList;
  }, [faqList]);

  /**
   * FAQ 카테고리 정제
   * --
   */
  const TapItems = React.useMemo(() => {
    if (!faqList.length) return [];

    const categories = faqList.reduce((acc, cur) => {
      const { inquiry_name } = cur;

      const isExist = acc[inquiry_name];

      if (!isExist) {
        acc[inquiry_name] = {
          label: inquiry_name,
          value: inquiry_name,
        };
      }
      return acc;
    }, {});

    return [{ label: '전체', value: 'ALL' }, ...Object.values(categories)];
  }, [faqList]);

  React.useEffect(() => {
    if (!TapItems.length) return;

    setTap(TapItems[0].value);
  }, [TapItems]);

  /* ===== RENDER ===== */
  return (
    <>
      <HelpQuestionsPresenter
        tapItem={TapItems}
        tap={tap}
        expandedQuestion={expandedQuestion}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        FAQ={FAQ}
        navigate={navigate}
        onTapChange={handleTapChange}
        onToggleQuestion={handleToggleQuestion}
        onNavigate={handleNavigate}
        screenSize={screenSize}
      />
    </>
  );
};

export default HelpQuestionsContainer;
